var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestRefund(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M6.99967 8.00033L5.33301 6.33366L6.99967 4.66699",
    stroke: "#656461",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.44966 13.9007L8.32899 13.154C8.12966 13.0213 7.87033 13.0213 7.67166 13.154L6.55099 13.9007C6.35166 14.0333 6.09233 14.0333 5.89366 13.9007L4.77366 13.1533C4.57433 13.0207 4.31499 13.0207 4.11633 13.1533L3.58833 13.5053C3.19433 13.768 2.66699 13.4853 2.66699 13.0127V3.18533C2.66699 2.53067 3.19766 2 3.85233 2H12.1483C12.803 2 13.3337 2.53067 13.3337 3.18533V13.0127C13.3337 13.486 12.8063 13.768 12.4123 13.506L11.8843 13.154C11.685 13.0213 11.4257 13.0213 11.227 13.154L10.1063 13.9007C9.90766 14.0333 9.64833 14.0333 9.44966 13.9007V13.9007Z",
    stroke: "#656461",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M5.33301 6.33301H8.83301C9.84567 6.33301 10.6663 7.15367 10.6663 8.16634V8.16634C10.6663 9.17901 9.84567 9.99967 8.83301 9.99967H7.99967",
    stroke: "#656461",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestRefund);
export default __webpack_public_path__ + "static/media/request-refund.f4a3ab7931a6431cef8fc887f7627b69.svg";
export { ForwardRef as ReactComponent };